import { render } from "./PropertySvg.vue?vue&type=template&id=e05569c2"
import script from "./PropertySvg.vue?vue&type=script&lang=js"
export * from "./PropertySvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__